module.exports = __webpack_public_path__ + "img/section-validation.89162d78.svg";